<template>
    <v-layout row wrap>
        <v-flex xs12 sm12 md10 lg8 xl7 class="pa-2">
            <p class="card-number" v-if="card_number">
                <span class="label">Številka Tuš Cash & Carry klub kartice:</span> {{ card_number }}
            </p>
            <empty-space />
            <div class="user-info" v-if="!silentLoading">
                <p v-if="name">
                    <label>Ime</label>
                    {{ name }}
                </p>
                <p v-if="lastname">
                    <label>Priimek</label>
                    {{ lastname }}
                </p>
                <p>
                    <label>Naziv podjetja in PE</label>
                    {{ company }} <template v-if="company_unit">- {{ company_unit }}</template>
                </p>
                <p v-if="address">
                    <label>Naslov</label>
                    {{ address }}
                </p>
                <p v-if="street">
                    <label>Ulica in hišna številka</label>
                    {{ street }}
                </p>
                <p v-if="zip">
                    <label>Poštna številka in mesto</label>
                    {{ zip }} {{ city }}
                </p>
                <p v-if="registration_number">
                    <label>Matična številka</label>
                    {{ registration_number }}
                </p>
                <p v-if="vat">
                    <label>Davčna številka</label>
                    {{ vat }}
                </p>
                <p>
                    <label>Elektronski naslov</label>
                    {{ email }}
                </p>
                <p v-if="mobileNo">
                    <label>Mobilna številka</label>
                    {{ mobileNo }}
                </p>
              <div>
                <br />
                <v-btn color="primary" href="https://www.tuscc.si/">Na spletno trgovino</v-btn>
                <v-btn color="primary" v-if="can_join" :to="{name: 'digital_onboarding'}">Včlanitev v Tuš Cash & Carry klub</v-btn>
              </div>
            </div>
            <div class="loader" v-if="silentLoading">
                <empty-space />
                <v-progress-circular :indeterminate="true" size="50" ></v-progress-circular>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    import EmptySpace from "../EmptySpace";
    import utils from "../../store/utils";

    export default {
        name: "ProfileTab",
        components: {EmptySpace},
        computed: {
            card_number: utils.vuexBuildSetGet(this, 'profile', 'user.card'),
            member: utils.vuexBuildSetGet(this, 'profile', 'user.member'),
            can_join: utils.vuexBuildSetGet(this, 'profile', 'user.can_join'),
            name: utils.vuexBuildSetGet(this, 'profile', 'user.personal.name'),
            lastname: utils.vuexBuildSetGet(this, 'profile', 'user.personal.surname'),
            email: utils.vuexBuildSetGet(this, 'profile', 'user.email'),
            company: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.name'),
            address: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.address'),
            vat: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.vat'),
            registration_number: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.registration_number'),
            company_unit: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.bunit'),
            street: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.street'),
            house_number: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.house_number'),
            zip: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.zip'),
            city: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.city'),
            mobileNo: utils.vuexBuildSetGet(this, 'profile', 'user.personal.mobile_phone'),
            silentLoading: utils.vuexBuildSetGet(this, 'profile', 'silentLoading'),
        },
        methods: {
            joinClub(){
                this.$router.push('/ustvari/vclanitev/korak1');
            }
        }
    }
</script>

<style scoped>
    @import "../../styles/variables.less";

    .loader {
        text-align: center;
    }

    .foreword {
        font-style: italic;
    }

    .user-info p{
        padding: 5px;
        margin-bottom: 0px;
        font-weight: bold;
        border-top: 1px solid #c1c1c1;
    }

    .user-info p:last-child{
        border-bottom: 1px solid #c1c1c1;
    }
    .user-info label{
        font-weight: normal;
        width: 250px;
        display: inline-block;
    }

    .card-number {
        font-weight: bold;
        font-size: 25px;
        font-weight: 400;
    }

    .card-number .label{
        font-weight: 600;
    }

</style>
